export default "/images/bff71d4aa347a2935cf2e66411d69df6.avif";